import React, { useRef, useEffect, useState } from "react";
import "./EducationCertifications.css";
import ScrollImage from "./images/scroll.png";
import fc from "./images/fc.png";
import csudh from "./images/csudh.png";
import csuf from "./images/csuf.png";
import data from "./images/data.png";
import cybersecurity from "./images/cybersecurity.png";
import neu from "./images/neu.png";
import knifeimage from "./images/pk.png";
import shipimage from "./images/pirate-ship.svg";

// Helper function to generate a random number within a range
const getRandomInRange = (min, max) => Math.random() * (max - min) + min;

// Randomize positions
const positions = [
  {
    title: "Fullerton College",
    x: getRandomInRange(6, 16), // Adjust range as needed
    y: getRandomInRange(10, 20),
    img: fc,
    time: "2017-2020",
    info: "Associate degree of Computer Science & mathematics",
  },
  {
    title: "CSUDH",
    x: getRandomInRange(20, 50),
    y: getRandomInRange(25, 40),
    img: csudh,
    time: "2020-2021",
    info: "Completed some prerequisite courses",
  },
  {
    title: "CSUF",
    x: getRandomInRange(70, 80),
    y: getRandomInRange(10, 40),
    img: csuf,
    time: "2021-2023",
    info: "Bachelor's degree of Computer Science",
  },
  {
    title: "Data Analytics Certif",
    x: getRandomInRange(7, 15),
    y: getRandomInRange(60, 80),
    img: data,
    time: "2022",
    info: "Certification issued by Google and Coursera",
  },
  {
    title: "Cybersecurity Certif",
    x: getRandomInRange(65, 75),
    y: getRandomInRange(47, 75),
    img: cybersecurity,
    time: "2023 Fall",
    info: "Certification issued by Google and Coursera",
  },
  {
    title: "Northeastern University",
    x: getRandomInRange(37, 50),
    y: getRandomInRange(75, 85),
    img: neu,
    time: "2024-Present",
    info: "Incomplete Master degree of Computer Science",
  },
];


const EducationCertifications = () => {
  const svgRef = useRef(null);
  const knifeRef = useRef(null);
  const sectionRef = useRef(null);
  const shipRef = useRef(null);
  const animationFrameId = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const updateDimensions = () => {
      if (svgRef.current) {
        const { clientWidth, clientHeight } = svgRef.current;
        setDimensions({ width: clientWidth, height: clientHeight });
      }
    };
  
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
  
    setTimeout(updateDimensions, 1000);
  
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);
  

  useEffect(() => {
    const section = sectionRef.current;
    const knife = knifeRef.current;
    if (!section || !knife) return;
    const handleMouseMove = (e) => {
      const rect = section.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      knife.style.left = `${x}px`;
      knife.style.top = `${y}px`;
      knife.style.visibility = "visible";
    };

    const handleClick = () => {
      knife.classList.add("wave");

      setTimeout(() => {
        knife.classList.remove("wave");
      }, 300);
    };

    const handleMouseLeave = () => {
      knife.style.visibility = "hidden";
    };

    section.addEventListener("mousemove", handleMouseMove);
    section.addEventListener("click", handleClick);
    section.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      section.removeEventListener("mousemove", handleMouseMove);
      section.removeEventListener("click", handleClick);
      section.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  useEffect(() => {
    const ship = shipRef.current;
    const section = sectionRef.current;
    const path = svgRef.current.querySelector(".red-curve");
    const bubble = document.querySelector(".bubble");
  
    if (!path || !ship) return;
  
    const pathLength = path.getTotalLength();
    let progress = 0;
    const speed = 1;
  
    const moveShip = () => {
      const point = path.getPointAtLength(progress);
      ship.style.left = `${point.x}px`;
      ship.style.top = `${point.y}px`;
  
      progress += speed;
      if (progress > pathLength) {
        progress = 0;
      }
      animationFrameId.current = requestAnimationFrame(moveShip);
    };
  
    const startAnimation = () => {
      animationFrameId.current = requestAnimationFrame(moveShip);
    };
  
    setTimeout(startAnimation, 100);
  
    if (!section || !bubble) return;
  
    const handleClickBB = () => {
      bubble.style.display = "block";
      setTimeout(() => {
        bubble.style.display = "none";
      }, 5000);
    };
  
    section.addEventListener("click", handleClickBB);
  
    return () => {
      section.removeEventListener("click", handleClickBB);
      cancelAnimationFrame(animationFrameId.current);
    };
  }, [dimensions]);
  

  const handleCardClose = () => {
    setSelected(null);
  };

  return (
    <div className="section num3" id="education-certifications" ref={sectionRef}>
      <div id="knife" className="knife" ref={knifeRef} style={{ visibility: "hidden" }}>
        <img src={knifeimage} alt="Knife" />
      </div>
      <div className="ship" id="ship" ref={shipRef} style={{ left: "10px", top: "10px" }}>
        <div className="bubble">Aye Aye, Captain!<br /> Click 'X' mark for more info</div>
        <img src={shipimage} alt="Pirate Ship" />
      </div>
      <div className="scroll-container">
        <img src={ScrollImage} alt="Parchment Scroll" className="scroll-image" />
        <h1 className="scroll-title">Education & Certifications</h1>
      </div>
      {positions.map((pos, index) => {
        const currentX = `${pos.x}%`;
        const currentY = `${pos.y}%`;

        return (
          <div
            key={index}
            className="symbol-container"
            style={{
              left: currentX,
              top: currentY,
              position: "absolute",
            }}
            onClick={() => setSelected(pos)}
          >
            <div className="eduCertOnHover">
              <div className="x-symbol">X</div>
              <div className="symbol-title">{pos.title}</div>
            </div>
          </div>
        );
      })}
      <svg ref={svgRef} className="svg-container">
        <path
          className="red-curve"
          d={`M ${positions[0].x * dimensions.width / 80} ${positions[0].y * dimensions.height / 90}
            ${positions.slice(1).map((pos, index) => {
              const prevPos = positions[index];
              const currentPos = positions[index + 1];
              if (!currentPos) return '';

              const controlX1 = (prevPos.x + currentPos.x) / 2 * dimensions.width / 90;
              const controlY1 = (prevPos.y + currentPos.y) / 2 * dimensions.height / 77;
              const controlX2 = (prevPos.x + currentPos.x) / 2 * dimensions.width / 100;
              const controlY2 = (prevPos.y + currentPos.y) / 2 * dimensions.height / 120;

              return `C ${controlX1} ${controlY1}, ${controlX2} ${controlY2}, ${currentPos.x * dimensions.width / 100} ${currentPos.y * dimensions.height / 100}`;
            }).join(' ')}`}
        />
      </svg>
      {selected && (
        <div className="popup-overlay" onClick={handleCardClose}>
          <div className="popup-card" onClick={(e) => e.stopPropagation()}>
            <h2>{selected.title}</h2>
            <img src={selected.img} alt={selected.title} className="popup-image" />
            <p>Time: {selected.time}</p>
            <h3>{selected.info}</h3>
            <button onClick={handleCardClose}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EducationCertifications;